// import {Component} from '@angular/core';

import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { fromEvent, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Component({
    selector: 'app-scroll-to-top',
    imports: [TranslateModule],
    templateUrl: './scroll-to-top.component.html',
    styleUrls: ['./scroll-to-top.component.css']
})
export class SctollToTopComponent implements  OnInit, OnDestroy{

  private scrollSubscription!: Subscription;
  private progressLength!: number;
  private button!: HTMLElement;
  private progress!: SVGRectElement;
  private scrollOffset = 500;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.button = this.el.nativeElement.querySelector('.btn-scroll-top');
    this.progress = this.el.nativeElement.querySelector('svg circle');

    this.progressLength = this.progress.getTotalLength();
    this.renderer.setStyle(this.progress, 'strokeDasharray', this.progressLength);
    this.renderer.setStyle(this.progress, 'strokeDashoffset', this.progressLength);

    this.scrollSubscription = fromEvent(window, 'scroll')
      .pipe(throttleTime(100))
      .subscribe(() => this.handleScroll());
  }

  private handleScroll(): void {
    const scrollPosition = window.scrollY;
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrollPercent = scrollPosition / scrollHeight || 0;
    const draw = this.progressLength * scrollPercent;

    this.renderer.setStyle(this.progress, 'strokeDashoffset', this.progressLength - draw);

    if (scrollPosition > this.scrollOffset) {
      this.renderer.addClass(this.button, 'show');
    } else {
      this.renderer.removeClass(this.button, 'show');
    }
  }

  public scrollToTop(){
    const bodyElement = document.querySelector('body');
    bodyElement!.scrollIntoView({behavior: 'smooth'});
  }

  ngOnDestroy(): void {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

}
